import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from '@app/main/admin/admin.component';
import { AdminAuthGuard } from '@app/auth/services/admin-auth.guard';
import { TemplateEditorModule } from '@app/main/template-editor/template-editor.module';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
    {
        path: '',
        canActivate: [AdminAuthGuard, MsalGuard],
        children: [
            { path: '', component: AdminComponent },
            {
                path: 'templates',
                children: [
                    { path: '', component: AdminComponent },
                    { path: 'editor', loadChildren: () => TemplateEditorModule },
                    {
                        path: ':action',
                        children: [
                            { path: '', component: AdminComponent },
                            { path: ':id', component: AdminComponent }
                        ]
                    }
                ]
            },
            {
                path: ':type',
                children: [
                    { path: '', component: AdminComponent },
                    {
                        path: ':action',
                        children: [
                            { path: '', component: AdminComponent },
                            { path: ':id', component: AdminComponent }
                        ]
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdminRoutingModule {}
